export default {
  getCollegeExam: (state) => state.collegeExam,
  getCollegeDocumentName: (state, getters, rootState) => (collegeDocumentId) => rootState
    .collegeDocuments
    .collegeDocuments
    .find((c) => c.id === collegeDocumentId)?.name ?? collegeDocumentId,
};
